import { Component, OnInit, Input } from '@angular/core';
import { InformacaoService } from 'src/app/service/informacao/informacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'servicos-acoes-adm-informacao',
  templateUrl: './servicos-acoes-adm-informacao.component.html',
  styleUrls: ['./servicos-acoes-adm-informacao.component.css']
})
export class ServicosAcoesAdmInformacaoComponent implements OnInit {

  @Input() visualizacao: boolean;
  listaClassificacaoComponente = [];
  charNum = 5000;

  constructor(
    public service: InformacaoService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) { }

  ngOnInit() {
    this.preencherListaClassificacao();
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.informacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.informacao.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.informacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.informacao.controls[str].touched &&
      this.service.informacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }
}
